export enum DECREE_FINANCIAL_VIEWTYPES {
  LIST = 'LIST',
  TABLE = 'TABLE'
}
